(function ($) {

    $.ZagScrollAnimate = function (element, options) {
        var component = element;
        var options = $.extend({}, $.ZagScrollAnimate.defaultOptions, options);
        ZagScrollAnimateSetup(component, options);

    };

    ZagScrollAnimateSetup = function (component, options) {

        options.targets.forEach((target) => {
            count = 0;
            if (options.order == "odd" || options.order == "even") {
                oddElems = [];
                evenElems = [];
                orderedElems = [];
                component.find(target.selector).each(function () {
                    if (count % 2 == 0) {
                        oddElems.push($(this));
                    } else {
                        evenElems.push($(this));
                    }
                    count++;
                });
                if (options.order == "odd") {
                    orderedElems = $.merge(oddElems, evenElems);
                }
                else {
                    orderedElems = $.merge(evenElems, oddElems);
                }

                for (i = 0; i < orderedElems.length; i++) {
                    $(orderedElems[i]).attr("data-scroll_animate_type", target.type);
                    $(orderedElems[i]).attr("data-scroll_animate_stagger", i * target.stagger);
                }
            }
            else {
                component.find(target.selector).each(function () {
                    $(this).attr("data-scroll_animate_type", target.type);
                    $(this).attr("data-scroll_animate_stagger", count * target.stagger);
                    count++;
                });
            }
        });

        var waypoint = new Waypoint({
            element: component,
            handler: function (direction) {
                ZagScrollAnimateExecute(this.element, direction);
            },
            triggerOnce: true,
            offset: options.offset + '%'
        })
    };

    ZagScrollAnimateExecute = function (waypoint, direction) {
        if (direction == "down") {
            waypoint.find("[data-scroll_animate_type]").each(function () {
                var element = $(this);
                var type = $(this).attr("data-scroll_animate_type");
                var stagger = $(this).attr("data-scroll_animate_stagger");

                setTimeout(
                    function (e) {
                        element.addClass("animate__animated");
                        element.addClass(type);
                    }, stagger);
            });
        }
    };

    $.fn.ZagScrollAnimate = (function (options) {
        return this.each(function () {
            (new $.ZagScrollAnimate($(this), options));
        });
    });

    $.ZagScrollAnimate.defaultOptions = { offset: 50, targets: [], order: "" };

})(jQuery);